import axios from "axios";

export const state = {
    vendors: [],
};

export const getters = {
    vendors: state => state.vendors,
};

export const mutations = {
    setVendors(state, newValue) {
        state.vendors = newValue
    },
};

export const actions = {
    fetchVendors({ commit }) {
        axios.get('/vendors').then(res => {
            commit('setVendors', res.data.vendors);
            
        })
    },
};
